import CheckboxIcon from "@/assets/icons/Checkbox.svg?react";
import { cn } from "@/lib/utils";

type FilterCheckboxProps = {
  checked: boolean;
  hovered?: boolean;
};

export default function FilterCheckbox({
  checked,
  hovered,
}: FilterCheckboxProps) {
  return (
    <div className="w-4 h-4 relative shrink-0">
      {checked ? (
        <CheckboxIcon className="w-4 h-4" />
      ) : (
        <div
          className={cn(
            "w-4 h-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-gray-900 border border-current rounded",
            { "border-teal-500": hovered },
          )}
        ></div>
      )}
    </div>
  );
}
